export const FILTERS = [
    {
        category: 'Business units',
        filterValues: [{
            id: 'bu_1',
            name: 'Design',
            count: 4
        }, {
            id: 'bu_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'bu_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'bu_4',
            name: 'HR',
            count: 10
        }, {
            id: 'bu_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'bu_6',
            name: 'PR',
            count: 9
        }]
    }, {
        category: 'Drivers',
        filterValues: [{
            id: 'dr_1',
            name: 'Design',
            count: 4
        }, {
            id: 'dr_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'dr_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'dr_4',
            name: 'HR',
            count: 10
        }, {
            id: 'dr_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'dr_6',
            name: 'PR',
            count: 9
        }]
    },  {
        category: 'Data sources',
        filterValues: [{
            id: 'ds_1',
            name: 'Design',
            count: 4
        }, {
            id: 'ds_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'ds_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'ds_4',
            name: 'HR',
            count: 10
        }, {
            id: 'ds_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'ds_6',
            name: 'PR',
            count: 9
        }]
    }, {
        category: 'Locations',
        filterValues: [{
            id: 'lo_1',
            name: 'Design',
            count: 4
        }, {
            id: 'lo_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'lo_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'lo_4',
            name: 'HR',
            count: 10
        }, {
            id: 'lo_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'lo_6',
            name: 'PR',
            count: 9
        }]
    }, {
        category: 'Related Risks',
        filterValues: [{
            id: 'rr_1',
            name: 'Design',
            count: 4
        }, {
            id: 'rr_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'rr_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'rr_4',
            name: 'HR',
            count: 10
        }, {
            id: 'rr_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'rr_6',
            name: 'PR',
            count: 9
        }]
    }, {
        category: 'Goals',
        filterValues: [{
            id: 'go_1',
            name: 'Design',
            count: 4
        }, {
            id: 'go_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'go_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'go_4',
            name: 'HR',
            count: 10
        }, {
            id: 'go_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'go_6',
            name: 'PR',
            count: 9
        }]
    }, {
        category: 'View Options',
        filterValues: [{
            id: 'vo_1',
            name: 'Design',
            count: 4
        }, {
            id: 'vo_2',
            name: 'Executive',
            count: 6
        }, {
            id: 'vo_3',
            name: 'Finance',
            count: 2
        }, {
            id: 'vo_4',
            name: 'HR',
            count: 10
        }, {
            id: 'vo_5',
            name: 'Logistics',
            count: 9
        }, {
            id: 'vo_6',
            name: 'PR',
            count: 9
        }]
    }
]